/** Design tokens shared with Maktab (the admin portal), so the nav and tables look the same in both portals. */
export const UI_TOKENS = {
	surfaceCard: "#FFFFFF",
	surfaceHover: "#F7F7F7",
	divider: "#EDEDED",
	borderSubtle: "#EDEDED",
	grey50: "#F2F2F2",
	textStrong: "#22031F",
	textBody: "#282828",
	textSecondary: "#66707A",
	sage600: "#789B73",
	sage700: "#5F805A",
	red600: "#B42318",
	borderDefault: "#E5E7EB",
	grey100: "#EDEDED",
	grey300: "#E3E9ED",
	grey400: "#CECECE",
	textMuted: "#9CA4AB",
	radiusLg: "12px",
	radiusPill: "100px",
	shadowSm: "0px 1px 2px 0px rgba(16,24,40,0.06)",
	radiusMd: "8px",
	overlay: "rgba(0,0,0,0.7)",
	shadowLg: "0px 12px 32px 0px rgba(16,24,40,0.14)",
	fontSans: `'General Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,
};

/** Maktab's 112% interface size — its tables are sized at this scale, so ours are too. */
export const UI_ZOOM = 1.12;

/** Rows-per-page choices in a list table's footer. */
export const TABLE_ROWS_PER_PAGE_OPTIONS = [10, 25, 50];
